import React from 'react';
import { Textarea } from "@shadcn-in-nx/ui/textarea";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@shadcn-in-nx/ui/tooltip";
import { CharCount } from "./shared/CharCount";

export function TextareaInput({
  value,
  onChange,
  onSave,
  onCancel,
  error,
  schema,
  autoFocus = true,
  className
}) {
  const stringValue = typeof value === 'string' ? value : String(value ?? '');

  const errorClass = error ? `${className} border-red-500 focus-visible:ring-red-500` : className;

  const handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
      onSave(value);
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div className='w-full h-full'>
      <TooltipProvider>
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
              <Textarea
                value={stringValue}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={() => onSave(value)}
                autoFocus={autoFocus}
                minLength={schema?.minLength}
                maxLength={schema?.maxLength}
                className={errorClass}
              />
          </TooltipTrigger>
          {error && (
            <TooltipContent side="top" className="bg-red-500 text-white font-medium text-xs">
              <p>{error}</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
      <CharCount value={stringValue} minLength={schema?.minLength} maxLength={schema?.maxLength} />
    </div>
  );
}
